import initializeComponent from 'Shared/react-initialize';
import { initializeNotificationsService } from 'Shared/Notifications/notification_service';
import { withBreakpointsContext } from 'Shared/utils/breakpoints';
import HeaderInteractive from './header-interactive';
import { MobileAppCartDrawer } from './components/dropdowns/cart_drawer_wrapper';
import './menu-analytics';

initializeNotificationsService();

initializeComponent('HeaderInteractive', withBreakpointsContext(HeaderInteractive));
initializeComponent('MobileAppCartDrawer', MobileAppCartDrawer);
